// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    useColorModeValue,
//    useToast,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
// import { addBillTerm, getBillTerm, updateBillTerm } from '../../../../../redux/actions/billTerm';
// import { getDaybook } from '../../../../../redux/actions/daybook';
// import { getAccount } from '../../../../../redux/actions/account';
// import { calculationSign, calculationMethod, METHOD_OF_ROUND_LI_TYPE } from 'utils/dropdownEnum';
// import '../../../companyProfile/css.css';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useGlobal, useUser } from 'contexts';

// const validationSchema = Yup.object().shape({
//    daybookId: Yup.string().required('daybook is required').min(1, 'daybook must be at least 1 selected'),
//    code: Yup.string().required('Code is required').max(1, 'Only one character is allowed'),
//    ordinal: Yup.number().required('Ordinal is required'),
// });

// const BillTermMasterForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, saveandcontinue = true }) => {
//    const [errors, setErrors] = useState({});
//    const [isLoading, setIsLoading] = useState(false);
//    const toast = useToast();
//    const { user } = useUser();
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const dbName = localStorage.getItem('dbName');
//    const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
//    const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
//    const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;
//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);
//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const daybookData = useSelector((state) => state.daybook?.list);
//    const userData = useSelector((state) => state?.account?.list);

//    const [row, setRow] = useState({
//       compIds: [],
//       daybookId: '',
//       code: '',
//       description: '',
//       sign: -1,
//       accountId: null,
//       formula: 'B',
//       ordinal: userData.length + 1,
//       methodOfCalc: 1,
//       percentValue: '',
//       roundingMethod: 1,
//    });

//    const clearFormData = () => {
//       setRow({
//          daybookId: '',
//          code: '',
//          description: '',
//          sign: -1,
//          accountId: null,
//          formula: 'B',
//          ordinal: userData.length + 1,
//          methodOfCalc: 1,
//          percentValue: '',
//          roundingMethod: 1,
//       });
//       setErrors({});
//    };

//    useEffect(() => {
//       if (user?.loginhistory?.companyId && !isEditMode) {
//          // Only set if not in edit mode and compIds is empty or doesn't include the user's company
//          setRow((prev) => {
//             if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
//                return {
//                   ...prev,
//                   compIds: [user.loginhistory.companyId],
//                };
//             }
//             return prev;
//          });
//       }
//    }, [user?.loginhistory?.companyId, isEditMode]);

//    useEffect(() => {
//       if (isOpen) {
//          dispatch(getDaybook({ companyId: user?.loginhistory?.companyId, ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }) }));
//          dispatch(getAccount({ compId: user?.loginhistory?.companyId, ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }) }));
//       }
//    }, [dispatch, isOpen]);

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData(); // Clear data when adding a new item
//          setRow((prev) => ({
//             ...prev,
//             compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
//          }));
//       } else if (isEditMode && currentRow) {
//          setRow({
//             daybookId: currentRow.daybookId || '',
//             code: currentRow.code || '',
//             description: currentRow.description || '',
//             sign: currentRow.sign || -1,
//             accountId: currentRow.accountId || null,
//             formula: currentRow.formula || 'B',
//             methodOfCalc: currentRow.methodOfCalc || 1,
//             percentValue: currentRow.percentValue || '',
//             ordinal: currentRow.ordinal || userData.length + 1,
//             roundingMethod: currentRow.roundingMethod || 1,
//             compIds: currentRow.compIds || [],
//          });
//       }
//    }, [isEditMode, currentRow]);

//    const validateForm = async () => {
//       try {
//          await validationSchema.validate(row, { abortEarly: false });
//          setErrors({});
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));

//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          delete newErrors[field];
//          return newErrors;
//       });
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          ordinal: Number(row.ordinal),
//          compIds: row.compIds,
//          daybookId: Number(row.daybookId),
//          accountId: row.accountId,
//          sign: Number(row.sign),
//          methodOfCalc: row.methodOfCalc ? Number(row.methodOfCalc) : null,
//          roundingMethod: row.roundingMethod ? Number(row.roundingMethod) : null,
//          percentValue: row.percentValue ? Number(row.percentValue) : null,
//       };

//       try {
//          if (isEditMode && currentRow?.id) {
//             processedData.id = currentRow.id;
//             await dispatch(updateBillTerm(processedData));
//          } else {
//             await dispatch(addBillTerm(processedData));
//             await dispatch(getBillTerm());
//          }
//          await dispatch(getBillTerm());
//          clearFormData();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          ordinal: Number(row.ordinal),
//          daybookId: Number(row.daybookId),
//          accountId: row.accountId,
//          sign: Number(row.sign),
//          methodOfCalc: row.methodOfCalc ? Number(row.methodOfCalc) : null,
//          roundingMethod: row.roundingMethod ? Number(row.roundingMethod) : null,
//          percentValue: row.percentValue ? Number(row.percentValue) : null,
//       };

//       try {
//          if (isEditMode && currentRow?.id) {
//             processedData.id = currentRow.id;
//             await dispatch(updateBillTerm(processedData));
//          } else {
//             await dispatch(addBillTerm(processedData));
//             await dispatch(getBillTerm());
//          }
//          await dispatch(getBillTerm());
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateForm();
//       if (isValid) {
//          onFormSubmit();
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateForm();
//       if (isValid) {
//          onsavecontinue();
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (e.key.toLowerCase() === 's') {
//             // e.preventDefault(); // prevent browser default (e.g. save page)

//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S
//             } else {
//                handleSubmit(); // S only
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             onClose();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateForm]);

//    const daybookRef = useRef();
//    const savefinishRef = useRef();
//    const ordinalRef = useRef();
//    const methodOfCalcRef = useRef();
//    const percentValueRef = useRef();
//    const roundingMethodRef = useRef();
//    const formulaRef = useRef();
//    const accountRef = useRef();
//    const signRef = useRef();
//    const descriptionRef = useRef();
//    const codeRef = useRef();

//    useEffect(() => {
//       setTimeout(() => {
//          daybookRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             onClose();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [onClose]);

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="4xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '20%', md: '10%', xl: '8%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Bill-Term' : 'Add New Bill-Term'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }} gap={3}>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'daybookId',
//                         'Daybook',
//                         daybookData,
//                         {
//                            value: row.daybookId,
//                            onChange: (value) => handleInputChange('daybookId', value),
//                            showCustomNoOptions: true,
//                            openfrom: 'daybook',
//                            ref: daybookRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  codeRef.current?.focus(); // Focus Apply GST
//                               } else if (e.key === 'Escape') {
//                                  onClose();
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         true,
//                         'Select Daybook',
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'code',
//                         'Code',
//                         {
//                            value: row.code,
//                            onChange: (e) => handleInputChange('code', e.target.value),
//                            ref: codeRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  descriptionRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true,
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'description',
//                         'Description',
//                         {
//                            value: row.description,
//                            onChange: (e) => handleInputChange('description', e.target.value),
//                            ref: descriptionRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  signRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         false,
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'sign',
//                         'Sign',
//                         calculationSign,
//                         {
//                            value: row.sign,
//                            onChange: (value) => handleInputChange('sign', value),
//                            ref: signRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  accountRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Sign',
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'accountId',
//                         'Account',
//                         userData,
//                         {
//                            value: row.accountId,
//                            onChange: (value) => handleInputChange('accountId', value),
//                            showCustomNoOptions: true,
//                            openfrom: 'account',
//                            ref: accountRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  formulaRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Account',
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'formula',
//                         'Formula',
//                         {
//                            value: row.formula,
//                            onChange: (e) => handleInputChange('formula', e.target.value),
//                            ref: formulaRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  methodOfCalcRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         false,
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'methodOfCalc',
//                         'Method Of Calculation',
//                         calculationMethod,
//                         {
//                            value: row.methodOfCalc,
//                            onChange: (value) => handleInputChange('methodOfCalc', value),
//                            ref: methodOfCalcRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  percentValueRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Method Of Calculation',
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'percentValue',
//                         'Percent Value',
//                         {
//                            value: row.percentValue,
//                            onChange: (e) => handleInputChange('percentValue', e.target.value),
//                            ref: percentValueRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  roundingMethodRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         false,
//                      )}
//                   </GridItem>
//                   <GridItem className="seperator-width">
//                      {renderDynamicDropdown(
//                         'roundingMethod',
//                         'Rounding Method',
//                         METHOD_OF_ROUND_LI_TYPE,
//                         {
//                            value: row.roundingMethod,
//                            onChange: (value) => handleInputChange('roundingMethod', value),
//                            ref: roundingMethodRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  ordinalRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         false,
//                         'Select Rounding Method',
//                      )}
//                   </GridItem>
//                   {shouldSendCompanyidBillTerm && (
//                      <GridItem className="seperator-width">
//                         {renderDynamicUiDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: row.compIds,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                   <GridItem className="seperator-width">
//                      {DynamicInput(
//                         'ordinal',
//                         'Ordinal',
//                         {
//                            value: row.ordinal,
//                            onChange: (e) => handleInputChange('ordinal', e.target.value),
//                            ref: ordinalRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  // e.preventDefault();
//                                  savefinishRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'number',
//                         true,
//                      )}
//                   </GridItem>
//                </Grid>
//             </ModalBody>
//             <ModalFooter>
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      mr={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   ref={savefinishRef}
//                   colorScheme="green"
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>
//                <Button variant="ghost" onClick={onClose} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default BillTermMasterForm;

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import {
   Grid,
   GridItem,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useColorMode,
   useToast,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
import { addBillTerm, getBillTerm, updateBillTerm } from '../../../../../redux/actions/billTerm';
import { getDaybook } from '../../../../../redux/actions/daybook';
import { getAccount } from '../../../../../redux/actions/account';
import { calculationSign, calculationMethod, METHOD_OF_ROUND_LI_TYPE } from 'utils/dropdownEnum';
import '../../../companyProfile/css.css';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal, useUser } from 'contexts';

const validationSchema = Yup.object().shape({
   daybookId: Yup.string().required('daybook is required').min(1, 'daybook must be at least 1 selected'),
   code: Yup.string().required('Code is required').max(1, 'Only one character is allowed'),
   ordinal: Yup.number().required('Ordinal is required'),
});

const BillTermMasterForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, saveandcontinue = true }) => {
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const toast = useToast();
   const { user } = useUser();
   const { companyList, userGlobalSettingsData } = useGlobal();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const dbName = localStorage.getItem('dbName');
   const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyidDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const textColor = isDark ? 'white' : '#1a202c';
   const labelColor = isDark ? 'gray.300' : 'gray.600';
   const dispatch = useDispatch();
   const daybookData = useSelector((state) => state.daybook?.list);
   const userData = useSelector((state) => state?.account?.list);

   const [row, setRow] = useState({
      compIds: [],
      daybookId: '',
      code: '',
      description: '',
      sign: -1,
      accountId: null,
      formula: 'B',
      ordinal: userData.length + 1,
      methodOfCalc: 1,
      percentValue: '',
      roundingMethod: 1,
   });

   const clearFormData = () => {
      setRow({
         daybookId: '',
         code: '',
         description: '',
         sign: -1,
         accountId: null,
         formula: 'B',
         ordinal: userData.length + 1,
         methodOfCalc: 1,
         percentValue: '',
         roundingMethod: 1,
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (isOpen) {
         dispatch(
            getDaybook({
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyidDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
         dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               status: true,
               ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, isOpen]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isEditMode && currentRow) {
         setRow({
            daybookId: currentRow.daybookId || '',
            code: currentRow.code || '',
            description: currentRow.description || '',
            sign: currentRow.sign || -1,
            accountId: currentRow.accountId || null,
            formula: currentRow.formula || 'B',
            methodOfCalc: currentRow.methodOfCalc || 1,
            percentValue: currentRow.percentValue || '',
            ordinal: currentRow.ordinal || userData.length + 1,
            roundingMethod: currentRow.roundingMethod || 1,
            compIds: currentRow.compIds || [],
         });
      }
   }, [isEditMode, currentRow]);

   const validateForm = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         delete newErrors[field];
         return newErrors;
      });
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         ordinal: Number(row.ordinal),
         compIds: row.compIds,
         daybookId: Number(row.daybookId),
         accountId: row.accountId,
         sign: Number(row.sign),
         methodOfCalc: row.methodOfCalc ? Number(row.methodOfCalc) : null,
         roundingMethod: row.roundingMethod ? Number(row.roundingMethod) : null,
         percentValue: row.percentValue ? Number(row.percentValue) : null,
      };

      try {
         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            await dispatch(updateBillTerm(processedData));
         } else {
            await dispatch(addBillTerm(processedData));
            await dispatch(getBillTerm());
         }
         await dispatch(getBillTerm());
         clearFormData();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         ordinal: Number(row.ordinal),
         daybookId: Number(row.daybookId),
         accountId: row.accountId,
         sign: Number(row.sign),
         methodOfCalc: row.methodOfCalc ? Number(row.methodOfCalc) : null,
         roundingMethod: row.roundingMethod ? Number(row.roundingMethod) : null,
         percentValue: row.percentValue ? Number(row.percentValue) : null,
      };

      try {
         if (isEditMode && currentRow?.id) {
            processedData.id = currentRow.id;
            await dispatch(updateBillTerm(processedData));
         } else {
            await dispatch(addBillTerm(processedData));
            await dispatch(getBillTerm());
         }
         await dispatch(getBillTerm());
         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateForm();
      if (isValid) {
         onFormSubmit();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateForm();
      if (isValid) {
         onsavecontinue();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            onClose();
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateForm]);

   const daybookRef = useRef();
   const savefinishRef = useRef();
   const savecontinueRef = useRef();
   const cancelRef = useRef();
   const ordinalRef = useRef();
   const methodOfCalcRef = useRef();
   const percentValueRef = useRef();
   const roundingMethodRef = useRef();
   const formulaRef = useRef();
   const accountRef = useRef();
   const signRef = useRef();
   const descriptionRef = useRef();
   const codeRef = useRef();

   useEffect(() => {
      setTimeout(() => {
         daybookRef.current?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            onClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [onClose]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
         <ModalOverlay className="backdrop-blur-sm bg-black/40" />
         <ModalContent
            className={`relative overflow-hidden ${isDark
               ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 border border-gray-700 shadow-2xl shadow-black/50'
               : 'bg-gradient-to-br from-white via-gray-50 to-white border border-gray-200 shadow-2xl shadow-blue-100/30'
               }`}
            borderRadius="2xl"
            mx="15px"
            mt={{ base: '10%', md: '5%', xl: '3%' }}>
            {/* Animated Background Elements */}
            <div
               className={`absolute inset-0 opacity-5 ${isDark
                  ? 'bg-gradient-to-r from-blue-500 via-purple-500 to-cyan-500'
                  : 'bg-gradient-to-r from-blue-300 via-purple-300 to-cyan-300'
                  }`}></div>

            {/* Header */}
            <ModalHeader
               className={`
  relative overflow-hidden
  ${isDark
                     ? 'bg-gradient-to-br from-gray-900 to-gray-800 border-b-2 border-blue-500 shadow-2xl'
                     : 'bg-gradient-to-br from-blue-50 to-white border-b border-blue-100 shadow-lg'
                  }
  py-6 px-8
`}>
               <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                     <div
                        className={`
        w-3 h-12 rounded-full transition-all duration-300
        ${isDark ? 'bg-blue-500 shadow-lg shadow-blue-500/50' : 'bg-blue-500 shadow-lg shadow-blue-400/50'}
      `}></div>
                     <div>
                        <h2
                           className={`
          text-2xl font-bold tracking-tight
          ${isDark ? 'text-white' : 'text-gray-800'}
        `}>
                           {isEditMode ? 'Edit Bill-Term' : 'Add New Bill-Term'}
                        </h2>
                        <p
                           className={`
          text-sm font-medium mt-1 transition-all duration-300
          ${isDark ? 'text-blue-300' : 'text-blue-600'}
        `}>
                           {isEditMode
                              ? 'Modify existing bill term configuration'
                              : 'Create a new bill term for your account'}
                        </p>
                     </div>
                  </div>
               </div>

               <div
                  className={`
    absolute bottom-0 left-0 w-full h-1
    ${isDark
                        ? 'bg-gradient-to-r from-blue-500 via-blue-600 to-purple-600'
                        : 'bg-gradient-to-r from-blue-400 via-blue-500 to-purple-500'
                     }
  `}></div>
            </ModalHeader>

            <ModalCloseButton
               className={`
  absolute top-6 right-6 w-10 h-10 rounded-xl transition-all duration-300 flex items-center justify-center border-2
  ${isDark
                     ? 'text-gray-300 bg-gray-800 border-gray-600 hover:bg-red-600 hover:border-red-500 hover:text-white shadow-lg'
                     : 'text-gray-600 bg-white border-gray-300 hover:bg-red-500 hover:border-red-400 hover:text-white shadow-lg'
                  }
  focus:outline-none focus:ring-4 focus:ring-red-500/30
`}
            />

            <ModalBody className="p-8 mt-2 relative">
               <Grid
                  templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)' }}
                  gap={6}
                  className="relative">
                  {/* Daybook Field */}
                  <GridItem className="group">
                     {renderDynamicDropdown(
                        'daybookId',
                        'Daybook',
                        daybookData,
                        {
                           value: row.daybookId,
                           onChange: (value) => handleInputChange('daybookId', value),
                           showCustomNoOptions: true,
                           openfrom: 'daybook',
                           ref: daybookRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 codeRef.current?.focus();
                              } else if (e.key === 'Escape') {
                                 onClose();
                              }
                           },
                        },
                        errors,
                        textColor,
                        true,
                        'Select Daybook',
                     )}
                  </GridItem>

                  {/* Code Field */}
                  <GridItem className="group">
                     {DynamicInput(
                        'code',
                        'Code',
                        {
                           value: row.code,
                           onChange: (e) => handleInputChange('code', e.target.value),
                           ref: codeRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 descriptionRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        'text',
                        true,
                     )}
                  </GridItem>

                  {/* Description Field */}
                  <GridItem className="group">
                     {DynamicInput(
                        'description',
                        'Description',
                        {
                           value: row.description,
                           onChange: (e) => handleInputChange('description', e.target.value),
                           ref: descriptionRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 signRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        'text',
                        false,
                     )}
                  </GridItem>

                  {/* Sign Field */}
                  <GridItem className="group">
                     {renderDynamicDropdown(
                        'sign',
                        'Sign',
                        calculationSign,
                        {
                           value: row.sign,
                           onChange: (value) => handleInputChange('sign', value),
                           ref: signRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 accountRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        false,
                        'Select Sign',
                     )}
                  </GridItem>

                  {/* Account Field - Premium Design */}
                  <GridItem className="group">
                     {renderDynamicDropdown(
                        'accountId',
                        'Account',
                        userData,
                        {
                           value: row.accountId,
                           onChange: (value) => handleInputChange('accountId', value),
                           showCustomNoOptions: true,
                           openfrom: 'account',
                           ref: accountRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 formulaRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        false,
                        'Select Account',
                     )}
                  </GridItem>

                  {/* Formula Field */}
                  <GridItem className="group">
                     {DynamicInput(
                        'formula',
                        'Formula',
                        {
                           value: row.formula,
                           onChange: (e) => handleInputChange('formula', e.target.value),
                           ref: formulaRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 methodOfCalcRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        'text',
                        false,
                     )}
                  </GridItem>

                  {/* Method Of Calculation Field */}
                  <GridItem className="group">
                     {renderDynamicDropdown(
                        'methodOfCalc',
                        'Method Of Calculation',
                        calculationMethod,
                        {
                           value: row.methodOfCalc,
                           onChange: (value) => handleInputChange('methodOfCalc', value),
                           ref: methodOfCalcRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 percentValueRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        false,
                        'Select Method Of Calculation',
                     )}
                  </GridItem>

                  {/* Percent Value Field */}
                  <GridItem className="group">
                     {DynamicInput(
                        'percentValue',
                        'Percent Value',
                        {
                           value: row.percentValue,
                           onChange: (e) => handleInputChange('percentValue', e.target.value),
                           ref: percentValueRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 roundingMethodRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        'number',
                        false,
                     )}
                  </GridItem>

                  {/* Rounding Method Field */}
                  <GridItem className="group">
                     {renderDynamicDropdown(
                        'roundingMethod',
                        'Rounding Method',
                        METHOD_OF_ROUND_LI_TYPE,
                        {
                           value: row.roundingMethod,
                           onChange: (value) => handleInputChange('roundingMethod', value),
                           ref: roundingMethodRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 ordinalRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        false,
                        'Select Rounding Method',
                     )}
                  </GridItem>

                  {/* Company Field - Premium Design */}
                  {shouldSendCompanyidBillTerm && (
                     <GridItem className="group">
                        {renderDynamicUiDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: row.compIds,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  )}

                  {/* Ordinal Field */}
                  <GridItem className="group">
                     {DynamicInput(
                        'ordinal',
                        'Ordinal',
                        {
                           value: row.ordinal,
                           onChange: (e) => handleInputChange('ordinal', e.target.value),
                           ref: ordinalRef,
                           onKeyDown: (e) => {
                              if (e.key === 'Enter' || e.key === 'Tab') {
                                 savefinishRef.current?.focus();
                              }
                           },
                        },
                        errors,
                        textColor,
                        'number',
                        true,
                     )}
                  </GridItem>
               </Grid>
            </ModalBody>

            {/* Footer */}
            <ModalFooter
               className={`relative ${isDark
                  ? 'bg-gradient-to-r from-gray-900/80 to-gray-800/80 border-t border-gray-700'
                  : 'bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200'
                  }`}
               py={6}
               px={8}>
               <div className="flex gap-3">
                  {!isEditMode && saveandcontinue === true && (
                     <Button
                        ref={savecontinueRef}
                        onClick={handlesavecontinue}
                        isLoading={isLoading}
                        disabled={isLoading}
                        className={`group relative overflow-hidden transition-all duration-300 ${isDark
                           ? 'bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 border border-emerald-500 shadow-lg shadow-emerald-900/30'
                           : 'bg-gradient-to-r from-emerald-500 to-green-500 hover:from-emerald-600 hover:to-green-600 border border-emerald-400 shadow-lg shadow-emerald-300/30'
                           } text-white font-semibold`}
                        borderRadius="xl"
                        px={8}
                        py={3}
                        _focus={{ boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.4)' }}
                        _hover={{ transform: 'translateY(-2px)' }}
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              savefinishRef.current?.focus();
                           }
                        }}>
                        <span className="relative z-10 flex items-center gap-2">
                           <span>💾</span> Save & Continue
                        </span>
                        <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                     </Button>
                  )}

                  <Button
                     onClick={handleSubmit}
                     isLoading={isLoading}
                     disabled={isLoading}
                     ref={savefinishRef}
                     className={`group relative overflow-hidden transition-all duration-300 ${isDark
                        ? 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 border border-blue-500 shadow-lg shadow-blue-900/30'
                        : 'bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 border border-blue-400 shadow-lg shadow-blue-300/30'
                        } text-white font-semibold`}
                     borderRadius="xl"
                     px={8}
                     py={3}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                     _hover={{ transform: 'translateY(-2px)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode) {
                              savecontinueRef.current?.focus();
                           }
                        }
                     }}>
                     <span className="relative z-10 flex items-center gap-2">
                        <span>✓</span> Save & Finish
                     </span>
                     <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
                  </Button>

                  <Button
                     ref={cancelRef}
                     variant="ghost"
                     onClick={onClose}
                     className={`transition-all duration-300 ${isDark
                        ? 'text-gray-300 hover:text-white hover:bg-red-600/20 border border-gray-600 hover:border-red-500'
                        : 'text-gray-700 hover:text-gray-900 hover:bg-red-50 border border-gray-300 hover:border-red-300'
                        } font-semibold`}
                     borderRadius="xl"
                     px={8}
                     py={3}
                     _focus={{ boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.4)' }}
                     _hover={{ transform: 'translateY(-2px)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           savefinishRef.current?.focus();
                        }
                     }}>
                     <span className="flex items-center gap-2">
                        <span>✕</span> Cancel
                     </span>
                  </Button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default BillTermMasterForm;
